import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import Spinner from 'components/Spinner'
import {
	useChat,
	RoomChatWindow,
	RoomMessageListContainer,
	ChatInputContainer,
} from 'features/Chat'

/**
 * The chat on a project viewed inside a location
 * (/locations/:id/projects/:projectId/chat).
 *
 * It is the same conversation as ProjectChat and keys off the same project id,
 * which is what ChatContext derives from the URL, so both routes show one
 * thread rather than two.
 *
 * Sets the project id directly rather than the old `~ProjectName` trigger; see
 * ProjectChat for why that trigger left a cold load showing an empty tab.
 */
const LocationChatScreen = () => {
	const { id, projectId } = useParams()
	const {
		actions: { setCurrentEventId },
	} = useChat()

	const loading = useSelector(state => state.locations.isLoading)
	const project = useSelector(state => state.projects.entities[projectId])

	useEffect(() => {
		if (projectId) setCurrentEventId(projectId)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [projectId, id])

	if (loading) return <Spinner containerHeight="50vh" />
	if (!project?.projectName) return null

	return (
		<RoomChatWindow>
			{/* shouldAlwaysDisplay is required: without it an empty room renders no
			    composer and could never receive its first message. */}
			<RoomMessageListContainer />
			<ChatInputContainer shouldAlwaysDisplay={true} />
		</RoomChatWindow>
	)
}

export default LocationChatScreen
